<template>
  <v-card v-if="chamada" class="text-center py-2 rounded-xl mt-0 pt-0 ml-1" flat :class="getClassForChamada()" :style="getCardStyle()">
    <div>
      <h6 :style="{ color: 'white' }">{{ chamada.codigoSigla }}{{ chamada.codigo }}</h6>
    </div>
    <div v-if="chamada.tipoChamada != 0">
      <div :class="getClassForLocal()" :style="{ backgroundColor: 'transparent' }">
        <div v-if="chamada.tipoChamada == 1" style="color: white;">
          {{ chamada.nomeConsultorio }}
        </div>
        <div :class="getClassForNomeLocal()" style="color: white;">
          {{ chamada.nomeLocal }}
        </div>
      </div>
    </div>
    <div v-else style="color: white;" class="text-truncate display-1 font-weight-bold">
      <div v-if="!!Number(chamada.guiche) || chamada.guiche == 0">
        Guichê
      </div>
      <div v-else>
        Local
      </div>
      <h3 class="text-truncate" style="color: orange;">
        {{ chamada.guiche }}
      </h3>
    </div>
  </v-card>
</template>

<script>
export default {
  props: ['chamada', 'user'],
  methods: {
    getCardStyle () {
      return {
        backgroundColor: 'transparent',
        borderColor: this.chamada.nomeLocal != this.user.nomeLocal ? 'var(--v-primary-base)' : 'var(--v-secondary-base)'
      }
    },
    getClassForChamada () {
      if (this.chamada.tipoChamada != 0 && this.chamada.nomeLocal != this.user.nomeLocal) {
        return 'white--text text-truncate display-2'
      } else {
        return 'white--text text-truncate display-2'
      }
    },
    getClassForLocal () {
      if (this.chamada.nomeLocal != this.user.nomeLocal) {
        return 'display-1 font-weight-bold'
      } else {
        return 'display-1 font-weight-bold'
      }
    },
    getClassForNomeLocal () {
      if (this.chamada.nomeLocal != this.user.nomeLocal) {
        return ''
      } else {
        return ''
      }
    },
    mapearLetraPrioridade (prioridade) {
      if (prioridade === 0) {
        return 'C'
      } else if (prioridade === 1) {
        return 'P'
      } else if (prioridade === 2) {
        return 'B'
      } else if (prioridade === 3) {
        return 'A'
      }
      return ''
    }
  }
}
</script>

<style scoped>
.v-card {
  background-color: transparent !important;
}
</style>
